export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "videoGif": {
    "title": "Video to GIF Converter",
    "subtitle": "Convert MP4, WEBM, MOV videos to animated GIFs online.",
    "privacy": "100% client-side",
    "noUpload": "no upload needed",
    "uploadTitle": "Upload Video",
    "uploadDesc": "Drag & drop or click to select. Supports MP4, WEBM, MOV up to 500MB.",
    "selectFile": "Select Video",
    "timeRange": "Time Range",
    "start": "Start",
    "end": "End",
    "play": "Play Selection",
    "pause": "Pause",
    "settings": "Output Settings",
    "fps": "FPS",
    "fpsDesc": "Higher FPS = smoother but larger file",
    "width": "Width",
    "widthDesc": "Height scales automatically",
    "estimated": "Estimated",
    "frames": "frames",
    "originalSize": "Original",
    "loadingEngine": "Loading video processing engine...",
    "loading": "Loading Engine...",
    "generating": "Generating...",
    "generate": "Generate GIF",
    "processing": "Processing video...",
    "result": "Result",
    "invalidFile": "Please upload a video file (MP4, WEBM, MOV)",
    "fileTooLarge": "File too large. Maximum 500MB.",
    "loadError": "Failed to load video. The format may not be supported.",
    "ffmpegError": "Failed to load video processing engine. Please refresh and try again.",
    "invalidRange": "Invalid time range",
    "generateError": "Failed to generate GIF: "
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 Video-to-GIF conversion runs entirely in your browser using ffmpeg.wasm. Your video files are processed locally and never uploaded to any external server."
    },
    "guide": {
      "title": "How to Use Video to GIF Converter",
      "description": "Turn any video clip into an animated GIF for social media, messaging, and web use — no upload required.",
      "steps": [
        {
          "title": "Upload your video",
          "description": "Select a video file from your device (MP4, WebM, MOV, AVI supported). The video loads directly into the browser for local processing."
        },
        {
          "title": "Trim and adjust settings",
          "description": "Use the timeline to select the exact start and end points for your GIF. Adjust frame rate, resolution, and quality to control file size and smoothness."
        },
        {
          "title": "Generate and download",
          "description": "Click the Generate GIF button to start the conversion. The ffmpeg.wasm engine processes the video locally in your browser, then you can download the finished GIF instantly."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Pure client-side video processing using ffmpeg.wasm",
        "Supports MP4, WebM, MOV, and AVI input formats",
        "Precise start/end trim with timeline scrubber",
        "Adjustable frame rate, resolution, and GIF quality",
        "Real-time preview before generating final output",
        "Zero server upload — video stays on your device"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Why does the first conversion take longer?",
          "answer": "The first time you use the tool, ffmpeg.wasm (a WebAssembly build of FFmpeg) must load into your browser. This is a one-time setup of about 5–15 MB. Subsequent conversions start much faster."
        },
        {
          "question": "What is the maximum video length?",
          "answer": "There is no fixed limit, but GIFs work best for short clips of 1–10 seconds. Longer videos will produce very large GIF files. For longer content, consider using the video compressor or trim feature."
        },
        {
          "question": "Can I convert GIF back to video?",
          "answer": "This tool focuses on video-to-GIF conversion. For the reverse process, you can use our Video Converter tool or download the original video if you still have it."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Image Compressor",
          "url": "/image/image-compressor",
          "description": "Optimize your GIF and image file sizes after conversion."
        },
        {
          "name": "Image Resizer",
          "url": "/image/image-resizer",
          "description": "Resize GIFs to exact dimensions for social platforms."
        },
        {
          "name": "Meme Generator",
          "url": "/image/meme-generator",
          "description": "Add captions and effects to your GIFs and images."
        }
      ]
    }
  }
};
